import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { FileEarmarkExcelFill, PrinterFill, BarChart } from "react-bootstrap-icons";
import { saAccountsBookReport } from "../store/api/Services";

const StaffAgencyAccountingBook = () => {

    const total = useRef({});
    const history = useHistory();
    const dispatch = useDispatch();
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const { list, filterData } = useSelector(state => { return { list: state.service.saAccBookReport, filterData: state.service.saAccBookFilters } });
    const [dateFilters, setDateFilters] = useState({
        DateFrom: filterData.DateFrom,
        DateTo: filterData.DateTo
    })
    if (list?.Data && Array.isArray(list.Data)) {
        total.current.Debit = list.Data.map(l => l.Debit).reduce((a, b) => a + b, 0);
        total.current.Credit = list.Data.map(l => l.Credit).reduce((a, b) => a + b, 0);
        total.current.RemainedDebit = total.current.Debit - total.current.Credit;
    }
    else {
        total.current.Debit = total.current.Credit = total.current.RemainedCredit = total.current.RemainedDebit = 0;
    }
    function search(data) {
        data.Skip = 0;
        if (!data.Take) {
            data.Take = 10;
        }
        const pDateFrom = document.getElementsByName("DateFrom")[0].value;
        //For Print
        data.PDateFrom = pDateFrom;
        //
        if (pDateFrom !== "") {
            data.DateFrom = dateFilters.DateFrom;
        }
        const pDateTo = document.getElementsByName("DateTo")[0].value;
        //For Print
        data.PDateTo = pDateTo;
        //
        if (pDateTo !== "") {
            data.DateTo = dateFilters.DateTo;
        }
        dispatch(saAccountsBookReport(data));

    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "حساب تفصیلی", colName: "AccountNameLThree", justInMobile: true },
        { colTitle: "تاریخ سند", colName: "PDocumentDate", justInMobile: true },
        { colTitle: "شماره سند", colName: "DocumentNumber", justInMobile: true },
        { colTitle: "شرح ردیف", colName: "RowDescription", justInMobile: true, colType: "string", maxLength: 300 },
        { colTitle: "بدهکار", colName: "Debit", justInMobile: false, colType: "currency" },
        { colTitle: "بستانکار", colName: "Credit", justInMobile: false, colType: "currency" },
        { colTitle: "مانده", colName: "RemainedDebit", justInMobile: false, colType: "currency", style: { direction: "ltr" } },
        { colTitle: "بدهکار/بستانکار", colName: "PRowAccountType", justInMobile: false },
    ];
    function toExcel() {
        const url = "api/DocumentsAPI/StaffAgencyAccountingBook";
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("StaffAgencyAccountingBook", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/StaffAgencyAccountingBook/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/StaffAgencyAccountingBook`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    useEffect(() => {
        document.body.classList = "notMain";
        search({ Take: 10, Skip: 0 });

    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBookOpen} size="lg" />
                    &nbsp;
                    گزارش حساب
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <Col md={2} className="form-group">
                                <label>از تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateFrom"
                                    value={dateFilters?.DateFrom ? momentJalaali(dateFilters?.DateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, DateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تا تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateTo"
                                    value={dateFilters?.DateTo ? momentJalaali(dateFilters.DateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, DateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه</label>
                                <select className="form-control" ref={register({})} name="Take" defaultValue={filterData?.Take ?? 10}>
                                    <option value={0}>انتخاب کنید</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرتب سازی بر اساس</label>
                                <select className="form-control" ref={register({})} name="SortBy" defaultValue={filterData?.SortBy ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="Date">تاریخ سند</option>
                                    <option value="Date DESC">تاریخ سند-نزولی</option>
                                    <option value="DocumentNumber">شماره سند</option>
                                    <option value="DocumentNumber DESC">شماره سند-نزولی</option>
                                </select>
                            </Col>
                        </Row>
                        <Col md={3}>
                            <Button type="submit" className="group-Btn-large mt-3"><BarChart size={15} />&nbsp;خروجی گزارش</Button>
                        </Col>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableColes} filterData={filterData} hasPaging={true}
                        searchMethod={(data) => dispatch(saAccountsBookReport(data))} reducerName="service" objectName="saAccBookReport" />
                    <table>
                        <thead>
                            <tr>
                                <th>بدهکار</th>
                                <th>بستانکار</th>
                                <th>مانده</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input className="tableRowInput" style={{ color: "red" }} value={total.current.Debit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: "blue" }} value={total.current.Credit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: total.current.RemainedDebit > 0 ? "red" : "blue", direction: "ltr", textAlign: "right" }} value={total.current.RemainedDebit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card.Body>
            </Card>
        </div>
    )

}
export default StaffAgencyAccountingBook;